var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 6.43319L3.03337 29.9999C2.74231 30.5039 2.58831 31.0754 2.58668 31.6574C2.58505 32.2394 2.73585 32.8117 3.02408 33.3174C3.31231 33.8231 3.72791 34.2444 4.22955 34.5396C4.73118 34.8348 5.30137 34.9935 5.88337 34.9999H34.1167C34.6987 34.9935 35.2689 34.8348 35.7705 34.5396C36.2722 34.2444 36.6878 33.8231 36.976 33.3174C37.2642 32.8117 37.415 32.2394 37.4134 31.6574C37.4118 31.0754 37.2578 30.5039 36.9667 29.9999L22.85 6.43319C22.5529 5.94336 22.1346 5.53839 21.6354 5.25733C21.1362 4.97627 20.5729 4.82861 20 4.82861C19.4271 4.82861 18.8639 4.97627 18.3647 5.25733C17.8655 5.53839 17.4472 5.94336 17.15 6.43319Z",
    fill: "#E4333E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V21.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.3335H20.0161",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/redAlert.c1dbc6dd33ccb044637c47a3247c8214.svg";
export { ForwardRef as ReactComponent };